import React from 'react';
export class Link extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const colorStyle = !this.props.disabled ? 'text-primary-600 hover:underline' : 'text-base-400';
            return (React.createElement(React.Fragment, null,
                React.createElement("a", { href: this.props.href, onClick: !this.props.disabled ? this.props.onClick : undefined, className: `${this.props.className} text-sm font-medium ${colorStyle} cursor-pointer`, style: this.props.style }, this.props.label)));
        };
    }
}
